import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "style-list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "翻译", -1)
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "别名", -1)
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" 简介 "),
  /*#__PURE__*/_createElementVNode("small", null, "支持 Markdown 语法")
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, "是否显示", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", null, "层级", -1)
const _hoisted_11 = { class: "style-list" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" 父级风格 "),
  /*#__PURE__*/_createElementVNode("small", null, "最终提交生效/尽量细化到子风格")
], -1)
const _hoisted_13 = { class: "style-list" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" 渊源风格 "),
  /*#__PURE__*/_createElementVNode("small", null, "最终提交生效/尽量细化到子风格")
], -1)
const _hoisted_15 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_StyleInput = _resolveComponent("StyleInput")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogFormVisible,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
    title: _ctx.dialogTitle
  }, {
    footer: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
        _createVNode(_component_el_button, {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogFormVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.doConfirmEdit()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, _ctx.loadings.formLoading]
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        model: _ctx.formEditStyle,
        "status-icon": "",
        "label-width": "80px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _hoisted_2,
              _createVNode(_component_el_input, {
                modelValue: _ctx.formEditStyle.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formEditStyle.name) = $event)),
                placeholder: "请输入内容",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeProfile()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_el_input, {
                modelValue: _ctx.formEditStyle.name_alt,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formEditStyle.name_alt) = $event)),
                placeholder: "请输入内容",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeProfile()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_input, {
                modelValue: _ctx.formEditStyle.profile,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formEditStyle.profile) = $event)),
                type: "textarea",
                rows: 4,
                placeholder: "请输入内容",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeProfile()))
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.userInfo.type.index >= 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.formEditStyle.show_in_list,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formEditStyle.show_in_list) = $event)),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeProfile()))
                  }, null, 8, ["modelValue"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.formEditStyle.show_in_list), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.userInfo.type.index >= 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formEditStyle.type.index,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formEditStyle.type.index) = $event)),
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeProfile())),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Top-Genre",
                        value: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Genre",
                        value: 2
                      }),
                      _createVNode(_component_el_option, {
                        label: "Style",
                        value: 3
                      }),
                      _createVNode(_component_el_option, {
                        label: "Sub-Style",
                        value: 4
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", null, [
              _createVNode(_component_StyleInput, {
                multiple: true,
                styles: _ctx.formEditStyle.parents,
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChooseStyle('parents', $event)))
              }, null, 8, ["styles"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", null, [
              _createVNode(_component_StyleInput, {
                multiple: true,
                styles: _ctx.formEditStyle.origins,
                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onChooseStyle('origins', $event)))
              }, null, 8, ["styles"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model"])), [
        [_directive_loading, _ctx.loadings.formLoading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}